"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryNotFoundError = void 0;
var countries_1 = __importDefault(require("../utils/countries"));
var countryNotFoundError = 'País não encontrado';
exports.countryNotFoundError = countryNotFoundError;
var validateCountryName = function (countryName) {
    var hasFoundCountry = countries_1.default.find(function (country) { return country.label.toLocaleLowerCase() === countryName.toLocaleLowerCase(); });
    if (hasFoundCountry)
        return false;
    return countryNotFoundError;
};
exports.default = validateCountryName;
//# sourceMappingURL=countryName.js.map